import { SnippetReferenceComponent } from './SnippetReferenceComponent';

export function SnippetReferenceComponentC(
  props: React.ComponentProps<typeof SnippetReferenceComponent>,
) {
  return <SnippetReferenceComponent {...props} />;
}
